<div class="hz-floating-embed" hz-if="isShow">
  <div class="floating-embed-mask"></div>
  <div class="floating-embed-content">
    <div class="iframe-header">
      <div class="iframe-close" hz-click="close()">X</div>
    </div>
    <iframe class="floating-iframe" src="{{iframeUrl}}"></iframe>
  </div>
</div>
<!--<div hz-for="(item, index) in this.list">-->
<!--  <div hz-if="$scope.item.id == 1" hz-click="this.log(item, $scope.index)">{item.name} {this.title}</div>-->
<!--</div>-->
<!--<div hz-for="item in this.list2">-->
<!--  <div hz-if="item.id == 2" hz-click="{this.log($scope.item)}">{item.name}</div>-->
<!--</div>-->
